<template>
  <div>
    <b-modal
      :title="isNew ? '新增帳單' : '修改帳單'"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      :no-close-on-backdrop="true"
      v-model="modalShow"
    >
      <b-form-group label-cols="4" label-cols-lg="2" label="帳單分類" class="star">
        <b-form-select
          v-model="data.class"
          :options="options.class"
          @change="changeClass()"
        ></b-form-select>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="帳單月份" class="star">
        <!-- <b-form-select
          v-model="data.month"
          :options="options.month"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>--請選擇帳單月份--</b-form-select-option>
          </template>
        </b-form-select> -->
        <b-form-input type="number" v-model="data.month"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="帳單期別" class="star">
        <b-form-input type="text" v-model="data.period"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="費用類別" class="star">
        <b-form-select
          v-model="data.type"
          :options="billType"
          @change="updateDom()"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>--請選擇費用類別--</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group v-if="data.type === 'S'" label-cols="4" label-cols-lg="2" label="促銷名稱" class="star">
        <b-form-input type="text" v-model="data.promotion_name"></b-form-input>
      </b-form-group>

      <b-form-group v-if="data.type === 'S'" label-cols="4" label-cols-lg="2" label="促銷期數" class="star">
        <b-form-input type="number" v-model="data.promotion_times"></b-form-input>
      </b-form-group>

      <b-form-group v-if="data.type === 'S'" label-cols="4" label-cols-lg="2" label="促銷總期數" class="star">
        <b-form-input type="number" v-model="data.promotion_times_total"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="金額" class="star">
        <b-form-input type="number" v-model="data.amount"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="繳款期限" class="star">
        <date-picker
          v-model="data.dead_at"
          :position="'right'"
          placeholder="請選擇繳款期限"
        ></date-picker>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="繳款日期" :class="{'star': data.class === 0}">
        <date-picker
          v-model="data.payment_at"
          :position="'right'"
          placeholder="請選擇繳款日期"
          :disabled="data.class === 1 || data.class === 2"
        ></date-picker>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="繳款來源" :class="{'star': data.class === 0}">
        <b-form-select
          v-model="data.payment_source"
          :options="options.payment"
          text-field="label"
          value-field="label"
          :disabled="data.class === 1 || data.class === 2"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>--請選擇繳款來源--</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group label-cols="4" label-cols-lg="2" label="備註">
        <b-form-input type="text" v-model="data.remark"></b-form-input>
      </b-form-group>

      <div class="text-center mt-4">
        <b-button
          class="mr-2"
          variant="success"
          size="sm"
          @click="sumit()"
        >
          確定
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          class="mr-4"
          @click="$emit('change', false)"
        >
          取消
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import billApi from "@/models/API/billApi";
import datePicker from '@/components/common/DatePicker';
import { billType } from "@/models/HELPERS/options.js";

export default {
  name: 'BillAddEditModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    isNew: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  components: {
    datePicker
  },
  data () {
    return {
      options: {
        class: [
          { value: 0, text: '已繳' },
          { value: 1, text: '未繳' },
          { value: 2, text: '壞帳' },
          { value: 3, text: '復會前已繳' }
        ],
        month: [
          { value: 1, text: '1月' },
          { value: 2, text: '2月' },
          { value: 3, text: '3月' },
          { value: 4, text: '4月' },
          { value: 5, text: '5月' },
          { value: 6, text: '6月' },
          { value: 7, text: '7月' },
          { value: 8, text: '8月' },
          { value: 9, text: '9月' },
          { value: 10, text: '10月' },
          { value: 11, text: '11月' },
          { value: 12, text: '12月' },
        ],
        payment: [
          {
            label: '現金',
            value: '現金'
          },
          {
            label: '超商',
            value: '超商'
          },
          {
            label: '新光',
            value: '新光'
          },
          {
            label: '萬事達',
            value: '萬事達'
          },
          {
            label: '郵局臨櫃',
            value: '郵局臨櫃'
          },
          {
            label: '郵局劃撥',
            value: '郵局劃撥'
          },
          {
            label: '網路ATM',
            value: '網路ATM'
          },
          {
            label: '台中銀行',
            value: '台中銀行'
          },
          {
            label: '支票',
            value: '支票'
          },
          {
            label: '自動',
            value: '自動'
          },
          {
            label: '年費抵用券',
            value: '年費抵用券'
          },
        ]
      },
      billType
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  mounted() {
    this.billApi = new billApi();
  },
  methods: {
    // 新增 | 更新 帳單
    sumit() {
      try {
        const required =
          ['class',
          'month',
          'period',
          'type',
          'amount',
          'dead_at'];

        if (this.data.class === 0) required.push('payment_at', 'payment_source');
        if (this.data.type === 'S') required.push('promotion_name', 'promotion_times', 'promotion_times_total');

        const data = this.data;
        const status = required.every(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        if (!status) {
          throw { message: '欄位請填寫完整', title: this.isNew ? '新增帳單' : '修改帳單' };
        }

        this.$emit('sumit');
      } catch(message) {
        this.billApi.toast(() => {}, message, false);
      }
    },
    // 更新畫面dom
    updateDom() {
      this.$forceUpdate();
    },
    // 改變帳單分類
    changeClass() {
      this.data.payment_at = '';
      this.data.payment_source = '';

      this.updateDom();
    }
  }
}
</script>

<style lang="scss" scoped>
.star {
  position: relative;
  &:before {
    content: "*";
    color: red;
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BillAddEditModal.vue